import axios, { AxiosPromise } from 'axios';
import { ITruckType } from '../../../@types/model/masterData/truckType/truckType';


export default class TruckTypeHttpService {
    public static getTruckTypeData() : AxiosPromise<Array<ITruckType>> {
        return axios.get(`${API_URL}/v1/TruckType/GetAllWeb`);
    }

    public static addOrUpdateTruckType(data : ITruckType) : AxiosPromise<ITruckType> {
        return axios.post(`${API_URL}/v1/TruckType/PostTruckType`, data);
    }

    public static deleteTruckType(truckTypeId : number) : AxiosPromise<ITruckType> {
        return axios.delete(`${API_URL}/v1/TruckType/Delete`, {
            params : { truckTypeId },
        });
    }
}
